import { createApiSlice } from "@common";
import {
  CRUD_CONVERT_LEAD_TO_ACCOUNT,
  CRUD_CONVERT_LEAD_TO_CONTACT,
  CRUD_CONVERT_LEAD_TO_OPPORTUNITY,
} from "@routes";

const apiConfig = [
  {
    name: "convertLeadToAccount",
    method: "post",
    url: CRUD_CONVERT_LEAD_TO_ACCOUNT,
    stateKey: "message",
  },
  {
    name: "convertLeadToContact",
    method: "post",
    url: CRUD_CONVERT_LEAD_TO_CONTACT,
    stateKey: "message",
  },
  {
    name: "convertLeadToOpportunity",
    method: "post",
    url: CRUD_CONVERT_LEAD_TO_OPPORTUNITY,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    loading: false,
    message: "",
  },
  reducers: {},
  extraReducers: {},
};

const { slice, thunks } = createApiSlice(
  "leadConversion",
  apiConfig,
  customReducers
);

const leadConversionSlice = slice;

export default leadConversionSlice.reducer;

export const {
  convertLeadToAccount,
  convertLeadToContact,
  convertLeadToOpportunity,
} = thunks;
